import { useNavigate } from 'react-router-dom'
import { supabase } from '@/integrations/supabase/client'

export function usePostLoginRedirect() {
  const navigate = useNavigate()

  const redirect = async () => {
    const { data, error } = await supabase.rpc('get_login_destination' as any)
    if (error) {
      // A failed RPC here usually means the stored session's token is no
      // longer valid server-side (expired/revoked), not that the user has
      // no destination. Falling back to '/dashboard' in that case sends
      // them into a route guard that will fail the same way and bounce
      // them right back to /auth — an infinite redirect loop. Clear the
      // broken session instead so they land on a clean sign-in screen.
      console.error('[usePostLoginRedirect] get_login_destination failed:', error)
      await supabase.auth.signOut()
      navigate('/auth?mode=signin', { replace: true })
      return
    }
    navigate((data as string) || '/dashboard', { replace: true })
  }

  return { redirect }
}
